import { render, staticRenderFns } from "./FormulaFloatingBallGroup.vue?vue&type=template&id=de4ed394"
import script from "./FormulaFloatingBallGroup.vue?vue&type=script&lang=js"
export * from "./FormulaFloatingBallGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports